import { render, staticRenderFns } from "./ParentMember.vue?vue&type=template&id=1ad920d0"
import script from "./ParentMember.vue?vue&type=script&lang=ts"
export * from "./ParentMember.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports